import React, { useEffect, useState } from 'react';
import './MovieModal.css';
import { getStreamUrl } from '../services/stream';

function MovieModal({ movie, onClose }) {
  const [streamUrl, setStreamUrl] = useState('');

  useEffect(() => {
    if (movie) {
      // Verifica se é série (TV) ou filme para gerar a URL correta
      const type = movie.first_air_date ? 'tv' : 'movie';
      const url = getStreamUrl(type, movie.id);
      setStreamUrl(url);
    }
  }, [movie]);

  if (!movie) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>&times;</button>
        
        <div className="modal-player-container">
          {streamUrl ? (
            <iframe
              src={streamUrl}
              className="modal-player"
              title={`Reproduzindo: ${movie.title || movie.name}`}
              allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
              allowFullScreen
              frameBorder="0"
              scrolling="no"
            />
          ) : (
            <div className="modal-loading">Carregando player...</div>
          )}
        </div>

        <div className="modal-info">
          <h2>{movie.title || movie.name}</h2>
          <div className="modal-metadata">
            <span>{movie.release_date || movie.first_air_date}</span>
            <span className="modal-rating">⭐ {movie.vote_average?.toFixed(1)}</span>
          </div>
          <p className="modal-overview">{movie.overview}</p>
        </div>
      </div>
    </div>
  );
}

export default MovieModal;
